import {useRef, useState} from "react";
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import {Breadcrumb, BreadcrumbItem, Container, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem} from "reactstrap";
import {Assortment} from "./Assortment";
import { Helmet } from 'react-helmet';

const sortOptions = [
  {value: 'default', label: 'По умолчанию'},
  {value: 'price-asc', label: 'Сначала дешёвые'},
  {value: 'price-desc', label: 'Сначала дорогие'},
  {value: 'name', label: 'По названию'},
]

export default function Catalog()
{
    const [params] = useSearchParams()
    const [sortBy, setSortBy] = useState('default')
    let collection = params.get("collection")
    let type = params.get("type")
    let top = null
    if(type == null && collection == null)
    {
        top = (<><Collections/><Types/></>)
    }
    return (<Container>
        <Helmet>
            <title>Каталог колясок iCandy | iCandy</title>
            <meta name="description" content="Каталог детских колясок iCandy. Peach, Lime, Orange, Cerium, Land Rover. Аксессуары, адаптеры, муфты." />
        </Helmet>
        <Breadcrumb>
            <BreadcrumbItem>
                <Link to='/'>
                    Главная
                </Link>
            </BreadcrumbItem>
             <BreadcrumbItem>
                 <Link to='/catalog'>
                     Каталог
                 </Link>
             </BreadcrumbItem>
            {(type != null)&&(<BreadcrumbItem active>
                 <Link to={"/catalog?type="+type}>
                     {type}
                 </Link>
             </BreadcrumbItem>)}
            {(collection != null)&&(<BreadcrumbItem active>
                 <Link to={"/catalog?collection="+collection}>
                     {collection}
                 </Link>
             </BreadcrumbItem>)}

        </Breadcrumb>
        {top}
        {!top && <div className="d-flex align-items-center justify-content-between mt-4 mb-3">
            <h2 className="mb-0">Каталог</h2>
            <UncontrolledDropdown>
              <DropdownToggle caret className="sort-dropdown-toggle">
                {sortOptions.find(o => o.value === sortBy)?.label || 'Сортировка'}
              </DropdownToggle>
              <DropdownMenu>
                {sortOptions.map(o => (
                  <DropdownItem key={o.value} active={sortBy === o.value} onClick={() => setSortBy(o.value)}>
                    {o.label}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </UncontrolledDropdown>
        </div>}
        {top && <h2 className="mt-5">Каталог</h2>}
        <Assortment collection={collection} type={type} sortBy={sortBy}/>
    </Container>)
}

function Category({name, params, img})
{
    const navigate = useNavigate()
    return(
        <div className="catalog-category-tile"
              onClick={()=> navigate('/catalog?'+params)}
              onKeyDown={e => { if (e.key === 'Enter') navigate('/catalog?'+params) }}
              role="link"
              tabIndex={0}>
            <div className="catalog-category-bg" style={{backgroundImage: `url(${img})`}} />
            <span>{name}</span>
        </div>)
}

function CollectionTilePanel({name, children})
{
    return(<div className="mb-5">
            <h2 className="mb-4">{name}</h2>
            <div className="catalog-category-container">
                {children}
            </div>
        </div>)
}

function Collections()
{
    return(<CollectionTilePanel name="Коллекции">
            <Category name='Peach' params="collection=Peach" img='peach.jpg'/>
            <Category name='Land Rover' params="collection=iCandy for Land Rover" img="land-rover.jpg"/>
            <Category name='Lime' params="collection=Lime" img="lime.jpg"/>
            <Category name='Orange' params="collection=Orange" img="orange.jpg"/>
            <Category name='Cerium' params="collection=Peach Designer Collection Cerium" img="cerium.jpg"/>
            <Category name='Universal' params="collection=Universal" img="universal.jpg"/>
    </CollectionTilePanel>)
}

function Types()
{
    return(<CollectionTilePanel name="Типы">
        <Category name='Коляски' params="type=Коляски" img='kalaska.png'/>
        <Category name='Муфты' params="type=Duo Pod Муфты" img="mufta.jpg"/>
        <Category name='Адаптеры' params="type=Адаптеры" img="adapter.jpg"/>
        <Category name='Аксессуары' params="type=Аксессуары" img="access.jpg"/>
        <Category name='Рамы' params="type=Расширения- Рамы" img="ramp.jpg"/>
    </CollectionTilePanel>)
}
